import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconWidth = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77499 9.69998C8.12499 9.34998 8.12499 8.77498 7.77499 8.42498C7.42499 8.07498 6.84999 8.07498 6.49999 8.42498L3.77499 11.15C3.42499 11.5 3.42499 12.075 3.77499 12.425L6.49999 15.15C6.67499 15.325 6.89999 15.4 7.12499 15.4C7.34999 15.4 7.57499 15.3 7.74999 15.15C8.09999 14.8 8.09999 14.225 7.74999 13.875L6.54999 12.675L17.675 12.675L16.475 13.875C16.125 14.225 16.125 14.8 16.475 15.15C16.825 15.5 17.4 15.5 17.75 15.15L20.475 12.425C20.825 12.075 20.825 11.5 20.475 11.15L17.75 8.44998C17.575 8.27498 17.35 8.19998 17.125 8.19998C16.9 8.19998 16.675 8.27498 16.5 8.44998C16.15 8.79998 16.15 9.37498 16.5 9.72498L17.7 10.925L6.59999 10.925L7.77499 9.69998Z" fill="currentColor" />
    <path d="M24 16.225V7.375C24 7.175 23.825 7 23.625 7H22.6C22.4 7 22.225 7.175 22.225 7.375V16.2C22.225 16.4 22.4 16.575 22.6 16.575H23.625C23.825 16.6 24 16.425 24 16.225Z" fill="currentColor" />
    <path d="M2.04999 16.225L2.04999 7.375C2.04999 7.175 1.87499 7 1.67499 7H0.624988C0.424988 7 0.249988 7.175 0.249988 7.375L0.249988 16.2C0.249988 16.4 0.424988 16.575 0.624988 16.575H1.64999C1.87499 16.6 2.04999 16.425 2.04999 16.225Z" fill="currentColor" />
  </SvgIcon>
);

export default IconWidth;
